import {Component} from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as fromRouter from '@app/root-store/router';
import { environment } from '@env/environment';
import * as fromUser from '@core/user/store';
import * as fromHeader from '@layout/header/store/header';

@Component({
  selector: 'rh-my-roche',
  templateUrl: './my-roche.container.html',
  styleUrls: ['./my-roche.container.scss']
})

export class MyRocheContainer  {
  public contactEmail$ = this.store$.pipe(select(fromHeader.selectMyRocheContactEmail))
  constructor(
    private store$: Store<fromRouter.State>
    ) {}

  goOutside(redirect: boolean) {
    this.store$.dispatch(fromUser.setMyRocheDisplayed({redirect}));
  }
}
